<template>
    <div>
        <nav class="header" :class="{change_header: scrollPosition > 75}">
            <div class="menu-button" @click="toggle" :class="{change_menu_button: scrollPosition > 75}">
                <img src="../assets/menu.webp" alt="icone menu">
            </div>
            <Drawer @close="toggle" align="left" :closeable="true">
                <div v-if="open">
                    <div class="menu">
                        <div class="menu-column">
                            <router-link class="is-tab nav-item" to="/">Accueil</router-link>
                            <hr>
                            <router-link class="is-tab nav-item" to="/la-carte">La Carte</router-link>
                            <hr>
                            <router-link class="is-tab nav-item" to="/contact">Contact</router-link>
                            <hr>
                            <router-link class="is-tab nav-item" to="/galerie">Photos</router-link>
                            <hr>
                            <router-link class="is-tab nav-item" to="/presentation">Présentation</router-link>
                            <hr>
                            <div class="dropdown is-tab nav-item">
                                <div class="account_button">Compte</div>
                                <div class="dropdown-content" v-if="!jwtToken && isLoggedIn === false">
                                    <router-link to="/inscription">Inscription</router-link>
                                    <router-link to="/connexion">Connexion</router-link>
                                </div>
                                <div class="dropdown-content" v-if="isLoggedIn">
                                    <router-link to="/compte">Mon Compte</router-link>
                                    <div class="signout" @click="signout">Déconnexion</div>
                                </div>
                            </div>
                            <hr>
                            <router-link class="is-tab nav-item" to="/panier">Panier</router-link>
                            <hr>
                        </div>
                    </div>
                </div>
            </Drawer>
            <div class="etoiles"></div>
            <div class="d-flex flex-row top_header" :class="{change_header: scrollPosition > 75}">
                <div class="menu_desktop" :class="{change_menu_desktop: scrollPosition > 75}">
                    <router-link class="is-tab nav-item" to="/presentation">Présentation</router-link>
                    <router-link class="is-tab nav-item" to="/la-carte">La Carte</router-link>
                    <router-link class="is-tab nav-item" to="/galerie">Photos</router-link>
                </div>
                <div class="div_logo">
                    <div class="logo" :class="{change_logo_triangle: scrollPosition > 75}">
                        <router-link to="/" class="logo_a">
                            <img src="../assets/TRIANGLE.webp" id="vwp-logo"
                                 alt="Logo Bus-Stop-Diner"/>
                        </router-link>
                    </div>
                    <div class="logo_mini">
                        <router-link to="/" class="logo_mini_a" :class="{change_logo: scrollPosition > 75}">
                            <img src="../assets/LOGO_DETOURE.webp" id="vwp-logo-mini"
                                 alt="Logo Bus-Stop-Diner"/>
                        </router-link>
                    </div>
                </div>
                <div class="menu_desktop" :class="{change_menu_desktop: scrollPosition > 75}">
                    <router-link class="is-tab nav-item" to="/contact">Contact</router-link>
                    <div class="dropdown is-tab nav-item">
                        <div>Mon Compte</div>
                        <div class="dropdown-content" v-if="!jwtToken && isLoggedIn === false"
                             :class="{change_dropdown_content: scrollPosition > 75}">
                            <router-link to="/inscription">Inscription</router-link>
                            <router-link to="/connexion">Connexion</router-link>
                        </div>
                        <div class="dropdown-content" v-if="isLoggedIn"
                             :class="{change_dropdown_content: scrollPosition > 75}">
                            <router-link to="/compte">Mon Compte</router-link>
                            <div class="signout" @click="signout">Déconnexion</div>
                        </div>
                    </div>
                    <router-link to="/panier" class="logo_bag">
                        <img src="../assets/shopping-bag.webp" id="shopping_bag"
                             alt="icone panier"/>
                    </router-link>
                </div>
            </div>
            <div class="exterieur d-flex flex-row" :class="{change_exterieur: scrollPosition > 75}">
                <div class="ext_left">
                    <img src="../assets/IMG_3600.webp" alt="Deventure du restaurant">
                </div>
                <div class="ext_right">
                    <img src="../assets/IMG_3605.webp" alt="Terrasse du restaurant">
                </div>
            </div>
            <div class="etoiles_bottom" :class="{change_etoiles: scrollPosition > 75}"></div>
        </nav>
    </div>
</template>

<script>
import Drawer from "vue-simple-drawer"
import {mapGetters} from "vuex"

export default {
    name: 'Header',
    data() {
        return {
            open: false,
            scrollPosition: null
        }
    },
    components: {
        Drawer
    },
    props: {
        msg: String
    },
    methods: {
        toggle() {
            this.open = !this.open
        },
        updateScroll() {
            this.scrollPosition = window.scrollY
        },
        signout() {
            this.$store.commit("user/signOut")
            this.$router.push("/")
        },
    },
    mounted() {
        window.addEventListener('scroll', this.updateScroll);
    },
    computed: {
        cartNb() {
            let list = this.$store.getters["shop/listToCart"]
            let singleTotal = [];
            list.forEach(total => {
                singleTotal.push(total.meta_data[0].value)
            })
            return singleTotal.reduce((accumulator, currentValue) => accumulator + currentValue, 0)
        },
        ...mapGetters("user", ["isLoggedIn", "jwtToken"])
    },
    watch: {
        $route() {
            this.open = false
        },
    }
}
</script>

<style scoped>

.header {
    font-family: 'PT Sans Narrow', sans-serif;
    font-weight: bold;
    font-size: 1.25rem;
    position: fixed;
    top: 0;
    z-index: 100;
    width: 100%;
    transition-duration: 0.5s;
    transition-timing-function: linear;
}

/*change header when scroll*/
.change_header {
    transition: height 0.5s linear;
    height: 50px !important;
}

.change_menu_button {
    top: 15px !important;
}

.change_menu_desktop {
    line-height: 85px !important;
}

.change_logo_triangle {
    opacity: 0;
    display: none;
    transition-duration: 1s;
    transition-timing-function: linear;
    transition-property: opacity;
}

.change_logo {
    opacity: 1 !important;
    transition-duration: 1s;
    transition-timing-function: linear;
    transition-property: opacity;
}

.change_exterieur {
    opacity: 0;
    transition: opacity 1s linear;
}

.change_etoiles {
    margin-top: 0 !important;
    transition: margin-top 0.5s linear;
}

.change_dropdown_content {
    top: 50px !important;
}

/*///////*/
.top_header {
    height: 40px;
    background-color: #fbe9d5;
}

.div_logo {
    text-align: center;
    width: 100%;
    z-index: 100;
}

.logo {
    position: absolute;
    width: 95%;
    margin-left: 2.5%;
}

.logo_a {
    transition-duration: 1s;
    transition-timing-function: linear;
}

.logo_mini {
    position: absolute;
    width: 100%;
}

.logo_mini_a {
    transition-duration: 1s;
    transition-timing-function: linear;
    opacity: 0;
}

.menu_desktop {
    display: none;
}

.exterieur {
    width: 100%;
    position: absolute;
    top: 45px;
    transition-duration: 1s;
    transition-timing-function: linear;
}

.ext_left {
    width: 50%;
}

.ext_left img {
    width: 100%;
}

.ext_right {
    width: 50%;
}

.ext_right img {
    width: 100%;
}

a {
    color: #000000 !important;
    width: 35%;
}

a:hover {
    color: #b7b7b7 !important;
    text-decoration: none;
}

.menu-button {
    position: inherit;
    left: -40px;
    top: 10px;
    color: white;
    z-index: 1000;
}

.menu-button span {
    display: none;
}

.menu-button img {
    width: 20%;
}

.menu {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-around;
}

.menu-column {
    display: flex;
    flex-direction: column;
    width: 60%;
    margin-bottom: 30px;
    text-align: center;
}

.nav-item {
    padding-top: 3px;
    padding-bottom: 3px;
    width: 100%;
}

hr {
    width: 35px;
    border-bottom: 1px solid #000000;
    margin-top: 0;
}

#vwp-logo {
    width: 50%;
}

#vwp-logo-mini {
    width: 30%;
}

::-webkit-scrollbar {
    display: none;
}

h3 {
    margin: 40px 0 0;
}

ul {
    list-style-type: none;
    padding: 0;
}

li {
    display: inline-block;
    margin: 0 10px;
}

.etoiles {
    width: 100%;
    height: 7px;
    background-image: url("../assets/BANDEAU_ETOILE.webp");
    background-size: cover;
    background-repeat-y: no-repeat;
    background-position-y: center;
}

.etoiles_bottom {
    width: 100%;
    height: 7px;
    background-image: url("../assets/BANDEAU_ETOILE.webp");
    background-size: cover;
    background-repeat-y: no-repeat;
    background-position-y: center;
    margin-top: 36.7%;
}

.account_button {
    color: black !important;
}

.account_button:hover {
    color: black !important;
}

.dropdown {
    position: relative;
    display: inline-block;
    margin-right: 10px;
}

.dropdown-content {
    display: none;
    position: absolute;
    background-color: #fbe9d5;
    min-width: 160px;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
    z-index: 1000;
    top: 33px;
    left: -40px;
}

.dropdown-content a {
    color: black !important;
    padding: 12px 16px;
    text-decoration: none;
    display: block;
    width: 160px;
}

.signout {
    color: black !important;
    padding: 12px 16px;
    text-decoration: none;
    display: block;
    width: 160px;
    cursor: pointer;
}

.dropdown-content a:hover {
    background-color: #F6F6F6;
}

.signout:hover {
    background-color: #F6F6F6;
}

.dropdown:hover .dropdown-content {
    display: block;
}

@media (min-width: 400px) {
    #vwp-logo-mini {
        width: 23%;
    }
}

@media (min-width: 576px) {
    /*change header when scroll*/
    .change_menu_button {
        top: 15px !important;
    }

    /*///////*/
    .etoiles {
        height: 8px;
        background-size: 130%;
    }

    .etoiles_bottom {
        height: 8px;
        background-size: 130%;
        margin-top: 37%;
    }

    #vwp-logo {
        width: 45%;
    }

    #vwp-logo-mini {
        width: 19%;
    }

    .menu-button {
        top: 11px;
    }

    .dropdown-content {
        min-width: 30vw;
        left: -2vw;
    }

    .dropdown-content a {
        width: 30vw;
    }
}

@media (min-width: 768px) {
    /*change header when scroll*/
    .change_menu_button {
        top: 18px !important;
    }

    /*///////*/
    .etoiles {
        height: 9px;
        background-size: 110%;
    }

    .etoiles_bottom {
        height: 9px;
        background-size: 110%;
        margin-top: 196px;
    }

    #vwp-logo {
        width: 32%;
    }

    #vwp-logo-mini {
        width: 14%;
    }

    .ext_left {
        width: 50%;
        height: 200px;
        background-image: url("../assets/IMG_3600.webp");
        background-repeat: no-repeat;
        background-size: cover;
        background-position-y: center;
    }

    .ext_left img {
        display: none;
    }

    .ext_right {
        width: 50%;
        height: 200px;
        background-image: url("../assets/IMG_3605.webp");
        background-repeat: no-repeat;
        background-size: cover;
        background-position-y: center;
    }

    .ext_right img {
        display: none;
    }

    .dropdown-content {
        min-width: 35vw;
        left: -4vw;
    }

    .dropdown-content a {
        width: 35vw;
    }
}

@media (min-width: 870px) {
    #vwp-logo {
        width: 28%;
    }

    #vwp-logo-mini {
        width: 12.5%;
    }
}

@media (min-width: 992px) {
    .change_menu_desktop {
        line-height: 48px !important;
    }

    .logo {
        position: absolute;
        width: 100%;
        margin-left: 0;
    }

    .menu-button {
        display: none;
    }

    .menu_desktop {
        display: flex;
        flex-direction: row;
        z-index: 1000;
        justify-content: space-around;
        line-height: 31px;
        width: 100%;
    }

    #vwp-logo {
        width: 70%;
    }

    #vwp-logo-mini {
        width: 34%;
    }

    .logo {
        width: 33%;
    }

    .logo_mini {
        width: 33%;
    }

    .etoiles {
        height: 10px;
        background-size: 100%;
    }

    .etoiles_bottom {
        height: 10px;
        background-size: 100%;
        margin-top: 195px;
    }

    #shopping_bag {
        width: 32px;
    }

    .dropdown-content {
        min-width: 15vw;
        left: -1vw;
    }

    .dropdown-content a {
        width: 15vw;
    }
}

@media (min-width: 1200px) {
    #vwp-logo {
        width: 58%;
    }

    #vwp-logo-mini {
        width: 28%;
    }

    #shopping_bag {
        width: 30px;
    }

    .dropdown-content {
        min-width: 10vw;
        left: 2vw;
    }

    .dropdown-content a {
        width: 10vw;
    }
}

@media (min-width: 1400px) {
    #vwp-logo {
        width: 50%;
    }
}

@media (min-width: 1600px) {
    #vwp-logo {
        width: 37%;
    }

    #vwp-logo-mini {
        width: 21%;
    }

    .logo {
        width: 33%;
    }

    .etoiles {
        height: 12px;
        background-size: 80%;
    }

    .etoiles_bottom {
        height: 12px;
        background-size: 80%;
        margin-top: 193px;
    }

    #shopping_bag {
        width: 28px;
    }
}

@media (min-width: 1800px) {
    #vwp-logo-mini {
        width: 18%;
    }

    #shopping_bag {
        width: 26px;
    }
}
</style>
